$(document).ready(function () {
  $(".Hero_main_banner .row").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    dots: true,
    fade: true,
    responsive: [
      {
        breakpoint: 768,
        settings: { arrows: false,},
      },
    ],
  });
});
$(document).ready(function () {
  $(".custom_slider .row").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 769,
        settings: {
          dots: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 376,
        settings: {
          dots: true,
          slidesToShow: 1,
        },
      },
    ],
  });
});
$(document).ready(function () {
  $(".project-slider .pr-slider").slick({
    autoplay: true,
    speed: 500,
    infinite: true,
    dots: true,
    fade: true,
    cssEase: "linear",
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
});
// faqs page tab js
$(document).ready(function () {
  const items = $(".faq-section-main .accordion button");
  function toggleAccordion() {
    const itemToggle = $(this).attr("aria-expanded");
    items.attr("aria-expanded", "false");
    items.next().slideUp();
    if (itemToggle == "false") {$(this).attr("aria-expanded", "true"); $(this).next().slideDown();}}
  items.on("click", toggleAccordion);
});
$(window).on("load", function () {
  var clear_filters_all =
    window.location.origin +
    window.location.pathname +
    "?q" +window.location.search.split("q").slice(-1).join("&");
$(".search_page_main .filtres-remove-js.clear_all").attr("href", clear_filters_all);});
$(document).ready(function (){ $(".skeleton").removeClass("skeleton");});
// account page tab js
$(document).ready(function () {
  setTimeout(function () {
    var tab_active = decodeURIComponent($(location).attr("hash"));
    $(".account-nav-tabs-main ul li a").each(function () {
      if (
        $(this).attr("data-navTab") == tab_active &&
        !$(this).parent().hasClass("active")
      ) {
        $(this).trigger("click");
      }
    });
  }, 500);
  $(".account-page-section .account-nav-tabs-main ul li a").click(function () {
    $(this)
      .parents(".account-nav-tabs-main")
      .find("a.active")
      .removeClass("active");
    $(this).addClass("active");
    var nav_this = $(this).attr("data-navTab");
    $(".account_tab_inner").children().hide();
    $(".account_tab_inner").find(nav_this).show();
    $("html, body").animate({ scrollTop: 0, behavior: "smooth" });
  });
});

// Process page scroll js
$(document).ready(function () {
  $(document).on(
    "click",
    ".process-tab-section .inner ul li a",
    function (event) {
      event.preventDefault();
      $(this).parents("ul").find("a.active").removeClass("active");
      $(this).addClass("active");
      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 130,
        },
        2000
      );
    }
  );
});
$(window).on("scroll", function () {
  if (document.querySelector("body").hasAttribute("data-tamplates")) {
    if ($(window).width() > 1300) {
      var scrollTop = $(window).scrollTop() + 700;
      if (
        scrollTop > $(".video_modal_section").offset().top ||
        $(window).scrollTop() < 200
      ) {
        $(".process-tab-section")
          .parent(".shopify-section")
          .removeClass("sticky_sec");
      } else {
        $(".process-tab-section")
          .parent(".shopify-section")
          .addClass("sticky_sec");
      }
    }
  }
});
$(window).resize(function () {
  if (document.querySelector("body").hasAttribute("data-tamplates")) {
    if ($(window).width() > 1300) {
      var scrollTop = $(window).scrollTop() + 700;
      if (scrollTop > $(".video_modal_section").offset().top) {
        $(".process-tab-section")
          .parent(".shopify-section")
          .removeClass("sticky_sec");
      } else {
        $(".process-tab-section")
          .parent(".shopify-section")
          .addClass("sticky_sec");
      }
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  AOS.init({
    selector: ".process-three-col-section [data-aos]",
    duration: 1000,
    offset: 200,
  });
});
document.addEventListener("DOMContentLoaded", function () {
  AOS.init({
    selector: ".process-two-col-section [data-aos]",
    duration: 1000,
    offset: 200,
  });
});

// footer newsletter mobile view js
$(window).resize(function () {
  if ($(window).width() < 790) {
    $("#form-acm_44953 .bee-form-row-1 .bee-col-1 .bee-block-1 button").before(
      $("#form-acm_44953 form .form-group.custom_checkbox")
    );
  } else {
    $("#form-acm_44953 .bee-form-row-1 .bee-col-1 .bee-block-1 form").append(
      $("#form-acm_44953 form .form-group.custom_checkbox")
    );
  }
});
// footer newsletter mobile view js
$(window).on("load", function () {
  setTimeout(function () {
    if ($(window).width() < 790) {
      $(
        "#form-acm_44953 .bee-form-row-1 .bee-col-1 .bee-block-1 button"
      ).before(
        $("footer .tt-footer-col .tt-newsletter .form-group.custom_checkbox")
      );
    } else {
      $("#form-acm_44953 .bee-form-row-1 .bee-col-1 .bee-block-1 form").append(
        $("footer .tt-footer-col .tt-newsletter .form-group.custom_checkbox")
      );
    }
  }, 1000);
});
// PDP page faq tab section js
$(document).ready(function () {
  $(".Product_template_main .tt-collapse-block .tt-item.custom_faq_head_box")
    .nextAll()
    .hide()
    .last()
    .show();
  $(".Product_template_main .tt-collapse-block .tt-item.custom_faq_head_box")
    .last()
    .show();
  $(
    ".Product_template_main .tt-collapse-block .tt-item.custom_faq_head_box .tt-collapse-title"
  ).click(function () {
    $(".Product_template_main .tt-collapse-block .tt-item.custom_faq_head_box")
      .nextAll()
      .toggle();
    $(".Product_template_main .tt-collapse-block .tt-item.custom_faq_head_box")
      .nextAll()
      .last()
      .toggle();
  });
});

function onSubmit(token) {
  window.Shopify.recaptchaV3.addToken(this, "create_customer");
  return false;
}
$(document).ready(function () {
  $(".sa-register").parents(".col-auto").removeClass("col-auto");
  $(".sa-register").parents(".row:eq(0)").removeClass("row");
  $(".sa-register").find("input").addClass("form-control");
});

$(document).ready(function () {
  $('form.reset_customer_password input[type="password"]').each(function () {
    $('form.reset_customer_password input[type="password"]').on(
      "input",
      function () {
        if (
          $("input#loginInputPassword").val() != "" &&
          $("input#loginInputEmail").val() != ""
        ) {
          $(".tt-login-form .tt-item form.reset_customer_password .btn").attr(
            "style",
            "opacity: 1; pointer-events: visible;"
          );
        } else {
          $(".tt-login-form .tt-item form.reset_customer_password .btn").attr(
            "style",
            "opacity: .5; pointer-events: none;"
          );
        }
      }
    );
  });
});

$(document).ready(function () {
  $(
    '.ragister-section-main .form-default input.form-control,.ragister-section-main .form-group.custom_checkbox.policy_checkboxs input[type="checkbox"]'
  ).on("input change focus", function (e) {
    var isInputFilled =
      $(".form-default input.form-control").filter(function () {
        return $(this).val() == "";
      }).length == 0;

    var isCheckboxChecked = $(
      '.ragister-section-main .form-group.custom_checkbox.policy_checkboxs input[type="checkbox"]'
    ).is(":checked");

    if (isInputFilled && isCheckboxChecked) {
      console.log("ok");
      $(".ragister-section-main .tt-login-form .tt-item .btn")
        .css({
          opacity: "1",
          "pointer-events": "inherit",
        })
        .removeClass("btn_disable");
    } else {
      e.preventDefault();
      console.log("not ok");
      $(".ragister-section-main .tt-login-form .tt-item .btn")
        .css({
          opacity: ".5",
          "pointer-events": "none",
        })
        .addClass("btn_disable");
    }
  });
});

// footer review link target remove
$(document).ready(function () {
  $("footer .tt-mobile-collapse .tt-collapse-content .tt-list li a").each(
    function () {
      if ($(this).text().includes("Review")) {
        $(this).attr("target", "");
      }
    }
  );
});

// PDP page product image scroll issue fixed
$(window).resize(function () {
  setTimeout(function () {
    if ($(window).width() < 768) {
      $(".zoom-product").unbind("touchmove");
      $(".zoom-product").unbind("MozMousePixelScroll");
      $(".zoom-product").unbind("DOMMouseScroll");
      $(".zoom-product").unbind("mousewheel");
    } else {
    }
  }, 500);
});
$(window).on("load", function () {
  setTimeout(function () {
    if ($(window).width() < 768) {
      $(".zoom-product").unbind("touchmove");
      $(".zoom-product").unbind("MozMousePixelScroll");
      $(".zoom-product").unbind("DOMMouseScroll");
      $(".zoom-product").unbind("mousewheel");
    } else {
    }
  }, 500);
});

window.refresh_add_to_cart_button = function () {
  $(".tt-cart-box .tt-title").each(function () {
    var product_title = $(this).text().trim();
    var found_box = $(".tt-product-listing")
      .find(".tt-col-item")
      .filter(function () {
        return $(this).find(".tt-title").text().trim() == product_title;
      });
    found_box.find(".tt-btn-addtocart").addClass("success-added");
    found_box.find(".tt-btn-addtocart").find("span.icon").addClass("icon-g-82");
    found_box.find(".tt-btn-addtocart").find("span:last").text("ADDED TO CART");
    var found_box2 = $(".tt-carousel-products")
      .find(".slick-slide")
      .filter(function () {
        return $(this).find(".tt-title").text().trim() == product_title;
      });
    found_box2.find(".tt-btn-addtocart").addClass("success-added");
    found_box2
      .find(".tt-btn-addtocart")
      .find("span.icon")
      .addClass("icon-g-82");
    found_box2
      .find(".tt-btn-addtocart")
      .find("span:last")
      .text("ADDED TO CART");
    var found_box3 = $(".tt-carousel-products-js")
      .find(".slick-slide")
      .filter(function () {
        return $(this).find(".tt-title").text().trim() == product_title;
      });
    found_box3.find(".tt-btn-addtocart").addClass("success-added");
    found_box3
      .find(".tt-btn-addtocart")
      .find("span.icon")
      .addClass("icon-g-82");
    found_box3
      .find(".tt-btn-addtocart")
      .find("span:last")
      .text("ADDED TO CART");
  });
};

$(document).ready(function () {
  $("#smallGallery")
    .find("a")
    .click(function (e) {
      setTimeout(function () {
        // Create a new custom event
        var customEvent = new CustomEvent("DOMMouseScroll", {
          detail: {
            /* additional data */
          },
          bubbles: true,
          cancelable: true,
        });
        // Dispatch the custom event
        $(".zoomContainer")[0].dispatchEvent(customEvent);

        var customEvent2 = new CustomEvent("mousewheel", {
          detail: {
            /* additional data */
          },
          bubbles: true,
          cancelable: true,
        });
        // Dispatch the custom event
        $(".zoomContainer")[0].dispatchEvent(customEvent2);

        var customEvent3 = new CustomEvent("MozMousePixelScroll", {
          detail: {
            /* additional data */
          },
          bubbles: true,
          cancelable: true,
        });
        // Dispatch the custom event
        $(".zoomContainer")[0].dispatchEvent(customEvent3);
      }, 1500);
    });
});

$(window).on("load", function () {
  //setTimeout(function() {
  $(".Product_template_main .pdp-loader-main").hide();
  $(".Product_template_main .stickprcol-js").removeClass("load_gif");
  //},200)
});
